import { HttpForm } from "../Support/HttpForm";
import axios from "axios";
export class OrderShow extends HttpForm {
    order = false;
    orderLoaded() {
        return this.order !== false;
    }
    getOrder(slug) {
        const url = '/api/redeem/campaign/order/' + slug;
        return axios.get(url)
            .then((response) => this.order = response.data.data)
            .catch(e => this.setError(e));
    }
}
